import { USER_TYPES, getUserType } from '../../../Utils/adminUserTypes';
import { readFocusChoice, readOrgZavvyEnabled } from './orgFeatures';

/**
 * One place that decides which Zavvy view a role gets. Mirrors role_profiles.py
 * on the AI backend and the canvas Decisions table.
 *
 *   admin       Tech Admin (Admin/Member), User - Admin, User - Management
 *   consultant  admin layout, no sharing, routines for me only
 *   auditor     Auditor - Admin / Member
 *   member      User - Member
 *   classic     Super Admin stays on classic Focus Mode ("as today")
 *   blocked     Regulator, Vendor, Guest and anything unknown
 */
export const ADMIN_ROLES = [USER_TYPES.TECH_ADMIN, USER_TYPES.TECH_MEMBER, USER_TYPES.USER_ADMIN, USER_TYPES.USER_MANAGEMENT];
export const CONSULTANT_ROLES = [USER_TYPES.CONSULTANT_ADMIN, USER_TYPES.CONSULTANT_MEMBER];
export const AUDITOR_ROLES = [USER_TYPES.AUDITOR_ADMIN, USER_TYPES.AUDITOR_MEMBER];
export const MEMBER_ROLES = [USER_TYPES.USER_MEMBER];
export const CLASSIC_ROLES = [USER_TYPES.SUPER_ADMIN];
/** The six roles that get the Project timeline group and timeline reminders. */
export const TIMELINE_ROLES = [...ADMIN_ROLES, ...CONSULTANT_ROLES];

export function zavvyView(role) {
  const r = (role || '').trim();
  if (ADMIN_ROLES.includes(r)) return 'admin';
  if (CONSULTANT_ROLES.includes(r)) return 'consultant';
  if (AUDITOR_ROLES.includes(r)) return 'auditor';
  if (MEMBER_ROLES.includes(r)) return 'member';
  if (CLASSIC_ROLES.includes(r)) return 'classic';
  return 'blocked';
}

export function readZavvyRole(userType) {
  const role = (userType || getUserType() || '').trim();
  const view = zavvyView(role);
  return {
    role,
    view,
    blocked: view === 'blocked',
    classic: view === 'classic',
    admin: view === 'admin',
    consultant: view === 'consultant',
    auditor: view === 'auditor',
    member: view === 'member',
    /** admin layout: admins and consultants */
    adminLike: view === 'admin' || view === 'consultant',
    timeline: TIMELINE_ROLES.includes(role),
    canShare: view === 'admin' || view === 'member',
    /** Can read the Team sessions list and the Team routines tab. */
    teamViewer: view === 'admin',
  };
}

export function shouldUseZavvy({ envEnabled, orgEnabled, choice, role }) {
  if (!envEnabled || !orgEnabled) return false;
  if (choice === 'classic') return false;
  if (role !== undefined && zavvyView(role) === 'classic') return false;
  return true;
}

/** Env switch, the organisation switch, this organisation's classic choice, and the role. */
export function zavvyActiveForUser() {
  return shouldUseZavvy({
    envEnabled: process.env.REACT_APP_ZAVVY_FOCUS_MODE === 'true',
    orgEnabled: readOrgZavvyEnabled(),
    choice: readFocusChoice(),
    role: getUserType(),
  });
}
